import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment';

@Component({
  selector: 'app-disclaimer.component',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
  providers: [CookieService]
})
export class DisclaimerComponent implements OnInit {

  constructor(public dialogRef : MatDialogRef<DisclaimerComponent>,
              private cookieService: CookieService,
              @Inject(MAT_DIALOG_DATA) public data : any) { }

  ngOnInit() {
  }

  closeDisclaimer() {
    this.cookieService.set('disclaimer',
      this.data.user.uid, moment().add(6, 'months').toDate());
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/home/disclaimer/disclaimer.component.ts